import Link from "next/link";
import Image from "next/image";
import { Container } from "@/components/shared/container";
import {
  BOOKING_PORTAL_CITIES,
  BOOKING_PORTAL_URL,
} from "@/lib/booking-portal";

const FOOTER_LINKS = {
  produkt: {
    label: "Produkt",
    links: [
      { label: "Funkcjonalności", href: "/funkcjonalnosci" },
      { label: "Vetina Booking", href: "/booking" },
      { label: "Cennik", href: "/#cennik" },
      { label: "Akademia", href: "/akademia" },
      { label: "FAQ", href: "/faq" },
    ],
  },
  porownaj: {
    label: "Porównaj",
    links: [
      { label: "Porównania", href: "/porownaj" },
      { label: "vs. Klinika XP", href: "/porownaj/klinika-xp" },
      { label: "vs. Veterinaro", href: "/porownaj/veterinaro" },
      { label: "vs. VetFile", href: "/porownaj/vetfile" },
      { label: "vs. Vetoteka", href: "/porownaj/vetoteka" },
      { label: "vs. Lecznica.eu", href: "/porownaj/lecznica-eu" },
    ],
  },
  weterynarz: {
    label: "Znajdź weterynarza",
    links: [
      { label: "Baza placówek", href: BOOKING_PORTAL_URL },
      ...BOOKING_PORTAL_CITIES.map((city) => ({
        label: `Weterynarz ${city.label}`,
        href: city.href,
      })),
    ],
  },
  zasoby: {
    label: "Zasoby",
    links: [
      { label: "Blog", href: "/blog" },
      { label: "Kontakt", href: "/kontakt" },
      { label: "Wsparcie aplikacji", href: "/support" },
      { label: "Audyt cyfryzacji", href: "/audyt-cyfryzacji" },
    ],
  },
  prawne: {
    label: "Prawne",
    links: [
      { label: "Polityka prywatności", href: "/polityka-prywatnosci" },
      { label: "Prywatność aplikacji", href: "/privacy" },
      { label: "Regulamin", href: "/regulamin" },
      { label: "Akcjonariat", href: "/akcjonariat" },
    ],
  },
};

export function Footer() {
  return (
    <footer className="border-t border-border py-12">
      <Container>
        <div className="grid grid-cols-2 md:grid-cols-6 gap-8">
          {/* Logo */}
          <div className="col-span-2 md:col-span-1">
            <Link href="/" className="flex items-center">
              <Image
                src="/images/logo.svg"
                alt="Vetina"
                width={120}
                height={32}
                className="h-8 w-auto"
              />
            </Link>
          </div>

          {/* Link columns */}
          {Object.values(FOOTER_LINKS).map((section) => (
            <div key={section.label}>
              <p className="text-sm font-semibold text-foreground mb-3">
                {section.label}
              </p>
              <ul className="space-y-2">
                {section.links.map((link) => (
                  <li key={link.href}>
                    <Link
                      href={link.href}
                      className="text-sm text-muted-foreground hover:text-foreground transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-border text-center md:text-left">
          <p className="text-sm text-muted-foreground">
            &copy; {new Date().getFullYear()} Vetina. Wszelkie prawa zastrzeżone.
          </p>
        </div>
      </Container>
    </footer>
  );
}
